import * as React from "react";

function ApprovalWorkflow(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 21 22" fill="none" {...props}>
      <path
        d="M5.75 16.75c.917-.977 2.223-1.489 3.532-1.5m1.968-4.5c0 1.105-.881 2-1.968 2-1.088 0-1.969-.895-1.969-2s.881-2 1.969-2c1.087 0 1.968.895 1.968 2z"
        stroke={props.color||"#D2D6DB"}
        strokeWidth={1.5}
        strokeLinecap="round"
      />
      <path
        d="M6.75 2.752c-2.644.01-4.059.102-4.975.97C.75 4.693.75 6.256.75 9.382v4.737c0 3.126 0 4.69 1.025 5.66 1.025.972 2.675.972 5.975.972h2m2-18c2.644.01 4.059.103 4.975.971 1.025.971 1.025 2.534 1.025 5.66v.869"
        stroke={props.color||"#D2D6DB"}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.022 2.382c.096-.415.144-.623.236-.792A1.64 1.64 0 018.341.797C8.544.75 8.78.75 9.25.75c.47 0 .706 0 .909.047a1.64 1.64 0 011.083.793c.092.17.14.377.236.792l.083.36c.17.735.255 1.103.127 1.386a1.03 1.03 0 01-.407.451c-.281.171-.699.171-1.533.171h-.996c-.834 0-1.252 0-1.533-.17a1.03 1.03 0 01-.407-.452c-.128-.283-.043-.65.127-1.386l.083-.36z"
        stroke={props.color||"#D2D6DB"}
        strokeWidth={1.5}
      />
      <path
        d="M14.74 16.517a.75.75 0 00-.646 1.354l.323-.677.323-.677zm.566 1.566l-.647.381a.75.75 0 001.323-.057l-.676-.324zm2.133-1.561a.75.75 0 10-.711-1.321l.355.66.356.66zm2.311.228H19A3.25 3.25 0 0115.75 20v1.5a4.75 4.75 0 004.75-4.75h-.75zm-4 4V20a3.25 3.25 0 01-3.25-3.25H11a4.75 4.75 0 004.75 4.75v-.75zm-4-4h.75a3.25 3.25 0 013.25-3.25V12A4.75 4.75 0 0011 16.75h.75zm4-4v.75A3.25 3.25 0 0119 16.75h1.5A4.75 4.75 0 0015.75 12v.75zm-1.333 4.444l-.324.677h-.001l-.002-.001a.074.074 0 00-.003-.002l-.004-.002c-.001 0-.001 0 0 0a1.292 1.292 0 01.163.113c.119.096.276.253.413.485l.647-.38.646-.381a3.297 3.297 0 00-.762-.89 2.783 2.783 0 00-.395-.267l-.034-.018a1.347 1.347 0 00-.012-.006l-.005-.002-.002-.002h-.001l-.324.676zm.889.89l.676.323c0 .001 0 .001 0 0l.006-.011a4.135 4.135 0 01.119-.228c.084-.154.205-.365.353-.588.317-.481.675-.895.979-1.058l-.356-.66-.355-.661c-.658.354-1.189 1.051-1.52 1.552a9.742 9.742 0 00-.566.98l-.009.018-.002.005-.001.002v.001l.676.324z"
        fill={props.color||"#D2D6DB"}
      />
    </svg>
  );
}

const MemoApprovalWorkflow = React.memo(ApprovalWorkflow);
export default MemoApprovalWorkflow;
